export default function CheckMaxLength(string, totalLength) 
{
    if(string.length<=totalLength)
    {
        return true;
    }
    return false;
}